import { AsyncPipe } from '@angular/common';
import { ChangeDetectorRef, Injector, OnDestroy, Pipe, PipeTransform } from '@angular/core';
import { map } from 'rxjs';
import { LANGUAGES, TranslateService } from 'src/app/core/translate';

@Pipe({
    name: 'getValueByLang',
    pure: false
})
export class GetValueByLangPipe implements PipeTransform, OnDestroy {
    private asyncPipe: AsyncPipe;

    public constructor(private translateService: TranslateService, private injector: Injector) {
        this.asyncPipe = new AsyncPipe(injector.get(ChangeDetectorRef));
    }

    transform(value: { nameAr: string; nameEn: string }): string {
        return this.asyncPipe.transform(
            this.translateService.currentLang$.pipe(
                map(lang => {
                    if (lang === LANGUAGES.AR) {
                        return value.nameAr;
                    } else if (lang === LANGUAGES.EN) {
                        return value.nameEn;
                    }
                    return value.nameAr;
                })
            )
        );
    }

    ngOnDestroy() {
        this.asyncPipe.ngOnDestroy();
    }
}
